import * as React from 'react';
import { useTranslation } from 'react-i18next';
import BaseDialog from 'common/components/base-dialog';
import { Box, Typography, Button } from '@mui/material';

interface CampaignModalDeleteProps {
    open: boolean;
    campaignName: string;
    handleClose: () => void;
    handleCopy: () => void;
}

const CampaignModalCopy: React.FC<CampaignModalDeleteProps> = ({
    open,
    campaignName,
    handleClose,
    handleCopy,
}) => {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <BaseDialog
                open={open}
                title={t('page.campaign.modal.copy.title')}
                fullWidth={false}
                maxWidth={false}
                sxContent={{
                    width: '978px',
                    padding: '50px 80px',
                }}
                onClose={handleClose}
            >
                <Box mt={'29px'}>
                    <Typography
                        sx={{
                            fontSize: '22px',
                            lineHeight: '27px',
                            textAlign: 'center',
                            color: 'rgba(0, 0, 0, 1)',
                        }}
                    >
                        <Typography
                            component="span"
                            sx={{
                                fontSize: '22px',
                                lineHeight: '27px',
                            }}
                        >
                            {t('page.campaign.modal.copy.question_prefix')}{' '}
                            &quot;
                        </Typography>
                        <Typography
                            component="strong"
                            fontWeight="bold"
                            sx={{
                                fontSize: '22px',
                                lineHeight: '27px',
                            }}
                        >
                            {campaignName}
                        </Typography>
                        &quot; {t('page.campaign.modal.copy.question_suffix')}
                    </Typography>
                    <Box
                        component="div"
                        display={'flex'}
                        justifyContent={'center'}
                        gap={'19px'}
                        mt={'39px'}
                    >
                        <Button
                            variant="outlined"
                            sx={{
                                width: '155px',
                                height: '60px',
                                borderRadius: '60px',
                                fontWeight: 'bold',
                                fontSize: '20px',
                                lineHeight: '24px',
                                textTransform: 'none',
                                borderWidth: '2px',
                                borderColor: (theme) =>
                                    theme.palette.primary.main,
                            }}
                            onClick={handleClose}
                        >
                            {t('page.campaign.modal.copy.button_cancel')}
                        </Button>
                        <Button
                            variant="contained"
                            onClick={handleCopy}
                            sx={{
                                boxShadow: 'none',
                                width: '155px',
                                height: '60px',
                                borderRadius: '60px',
                                fontWeight: 'bold',
                                fontSize: '20px',
                                lineHeight: '24px',
                                textTransform: 'none',
                            }}
                        >
                            {t('page.campaign.modal.copy.button_copy')}
                        </Button>
                    </Box>
                </Box>
            </BaseDialog>
        </React.Fragment>
    );
};

export default CampaignModalCopy;
